<script setup lang="ts">
import {ref, watch} from 'vue';

const props = defineProps<{
  slideIndex: number;
}>();

// Empty string on initial mount = no animation on first render
const direction = ref('');

watch(() => props.slideIndex, (val: number, oldVal: number) => {
  direction.value = oldVal < val ? 'left' : 'right';
});

</script>
<template>
  <div class="slider">
    <div :key="slideIndex" class="slide" :class="direction">
      <slot/>
    </div>
  </div>
</template>
<style scoped lang="scss">
.slider {
  overflow: hidden;
  height: 100%;
}

.slide {
  height: 100%;
  overflow-y: auto;

  &.left {
    animation: enter-from-right 0.5s ease-out backwards;
  }

  &.right {
    animation: enter-from-left 0.5s ease-out backwards;
  }
}

@keyframes enter-from-right {
  from {
    transform: translateX(40%);
    opacity: 0;
  }
}

@keyframes enter-from-left {
  from {
    transform: translateX(-40%);
    opacity: 0;
  }
}
</style>
